import React from 'react';
import { useParams } from "react-router";

type Params = {
    reportId?: string;
}

const ReportDetails = () => {
    let params = useParams<Params>();
    console.log(params);
    return (
        <div>
            Report details {params?.reportId}
        </div>
    );
};

export default ReportDetails;